module.exports = __webpack_public_path__ + "media/3.ef2c2fc6.mp3";